import React from 'react'
import { useParams } from 'react-router-dom'
import useStore from '../utlis/customHooks/useStore'
import { ArrowDropDownSharp } from '@mui/icons-material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Divider } from '@mui/material';


export default function CoinDetails() {

    const {state} = useStore()

    const parseUrl = (pair) => {
        let coin = pair.replaceAll("USDT", "")
        return `https://lcw.nyc3.cdn.digitaloceanspaces.com/production/currencies/64/${coin.toLowerCase()}.png`
    }

    const calcpnlByPair = (data) => {
      let totalAmount = (data.winning_trades + data.losing_trades) * 100
      let amountLeft = (data.total_gain + data.total_loss) + (100 * (data.winning_trades + data.losing_trades))
      let pnl = (amountLeft - totalAmount)
      return Number(pnl).toFixed(2)
    }

    const calcTotalTrades = (data) => {
      return (data.winning_trades + data.losing_trades)
    }

    const calcPW = (data) => {
        return (data.winning_trades / (data.winning_trades + data.losing_trades) * 100).toFixed(2)
    }

    const calcPL = (data) => {
        return (data.losing_trades / (data.winning_trades + data.losing_trades) * 100).toFixed(2)
    }

    const calcAvgWin = (data) => {
        if(data.winning_trades === 0) {
            return 0
        }
        return (data.total_gain / data.winning_trades).toFixed(2)
    }

    const calcAvgLoss = (data) => {
        if(data.losing_trades === 0) {
            return 0
        }
        return (data.total_loss / data.losing_trades).toFixed(2)
    }

    const calcAPPT = (data) => {
        let totalTrades = (data.winning_trades + data.losing_trades)
        if(totalTrades === 0) {
            return 0
        }
        let pw = data.winning_trades / totalTrades;
        let pl = data.losing_trades / totalTrades;
        let avg_win = data.total_gain /data.winning_trades;
        if(data.winning_trades === 0) {
            avg_win = 0
        }
        let avg_loss = Math.abs(data.total_loss) / data.losing_trades;
        if(data.losing_trades === 0) {
            avg_loss = 0
        }
        let appt = (pw * avg_win) - (pl * avg_loss)
        return Number(appt).toFixed(2) 
    }
    

    const {id, pair} = useParams()
    return (
        <div className="container px-5">
            <div class="flex flex-row font-sans space-x-5">
              <div className="relative">
                <img src={parseUrl(pair)} alt="" width={64} className="mx-auto"/>
              </div>
              <div className="relative flex flex-col space-y-1">
                  <span className="text-xl font-semibold">{pair}</span>
                  <div className="flex flex-row">
                  <span>
                    {calcpnlByPair(state.firestore[id].analytics.coins[pair]) > 0 && <span className="flex flex-row "> 
                            <span className="text-green-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                            <span className="text-sm text-green-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[pair])}%) </span>
                        </span>}

                    {calcpnlByPair(state.firestore[id].analytics.coins[pair]) == 0 && <span className="flex flex-row "> 
                          <span className="text-gray-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropUpIcon /> </span>
                          <span className="text-sm text-gray-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[pair])}%) </span>
                      </span>}

                      {calcpnlByPair(state.firestore[id].analytics.coins[pair]) < 0 && <span className="flex flex-row "> 
                          <span className="text-red-600 -mx-1 text-sm" style={{marginTop : '-2px'}}> <ArrowDropDownSharp/> </span>
                          <span className="text-sm text-red-600"> ({calcpnlByPair(state.firestore[id].analytics.coins[pair])}%) </span>   
                      </span>}

                    </span>

                    <span className="mx-1">•</span>
                    <span style={{marginTop : '-2px'}}>
                        <span className="text-gray-600 text-sm"> {calcTotalTrades(state.firestore[id].analytics.coins[pair])} Trades </span>
                    </span>
                  </div>
              </div>
            </div>

            <Divider horizontal sx={{marginTop : '10px'}} />

            <div className="md:grid grid-cols-12 hidden">
                <div className="col-span-6">
                    <div className="my-3">
                        <span className="text-sm font-semibold">Trade Analytics</span>
                        <span className="mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                            By Coin
                          </span>
                    </div>
                    <div className="p-1 flex flex-row flex-wrap my-4 justify-center">
                        <div className="grid grid-cols-12 space-x-4 mb-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Winning Trades
                                </span>
                                <span className={`text-center ${state.firestore[id].analytics.coins[pair].winning_trades > 0 ? 'text-green-500' : ''}`}>
                                    {state.firestore[id].analytics.coins[pair].winning_trades}
                                </span>
                            </span>

                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Total Gains
                                </span>
                                <span className={`text-center ${Number(state.firestore[id].analytics.coins[pair].total_gain).toFixed(2) > 0.00 ? 'text-green-500' : ''}`}>
                                   $ {Number(state.firestore[id].analytics.coins[pair].total_gain).toFixed(2)}
                                </span>
                            </span>

                        </div>

                        <div className="grid grid-cols-12 space-x-4 mb-4 ml-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Losing Trades
                                </span>
                                <span className={`text-center ${state.firestore[id].analytics.coins[pair].losing_trades > 0 ? 'text-red-500' : ''}`}>
                                    {state.firestore[id].analytics.coins[pair].losing_trades}
                                </span>
                            </span>

                            <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Total Losses
                                </span>
                                <span className={`text-center ${Number(state.firestore[id].analytics.coins[pair].total_loss).toFixed(2) !== 0.00 ? 'text-red-500' : ''}`}>
                                    ${Number(state.firestore[id].analytics.coins[pair].total_loss).toFixed(2)}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-6">
                <div className="my-3">
                        <span className="text-sm font-semibold">Strategy Statistics</span>
                        <span className="mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                            By Coin
                          </span>
                    </div>
                    <div className="p-1 flex flex-row flex-wrap my-4 justify-center">
                        <div className="grid grid-cols-12 space-x-4 mb-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Strategy
                                </span>
                                <span className="text-center">
                                    {state.firestore[id].strategy_details.name}
                                </span>
                            </span>

                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    APPT
                                </span>
                                <span className={`text-center ${calcAPPT(state.firestore[id].analytics.coins[pair]) > 0.00 ? 'text-green-500' : 'text-red-500'}`}>
                                   $ {calcAPPT(state.firestore[id].analytics.coins[pair])}
                                </span>
                            </span>

                        </div>

                        <div className="grid grid-cols-12 space-x-4 mb-4 ml-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    P(Win)
                                </span>
                                <span className={`text-center ${calcPW(state.firestore[id].analytics.coins[pair]) == 0 ? '' : 'text-green-500'}`}>
                                    {calcPW(state.firestore[id].analytics.coins[pair])}%
                                </span>
                            </span>

                            <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    P(Loss)
                                </span>
                                <span className={`text-center ${calcPL(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-red-500'}`}>
                                    {calcPL(state.firestore[id].analytics.coins[pair])}%
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-12 my-12">
                    <div className=" text-xl text-center my-6">
                        <span className="font-semibold"> Average Wins & Losses </span>
                    </div>
                    <div className="flex flex-row justify-center text-xl">
                        <span className="col-span-6 mx-5 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                            <span className="text-gray-600 text-xs">
                                Avg.(Win)
                            </span>
                            <span className={`text-center ${calcAvgWin(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-green-500'}`}>
                                $ {calcAvgWin(state.firestore[id].analytics.coins[pair])}
                            </span>
                        </span>

                        <span className="mx-5 col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                            <span className="text-gray-600 text-xs">
                                Avg.(Loss)
                            </span>
                            <span className={`text-center ${calcAvgLoss(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-red-500'}`}>
                                $ {calcAvgLoss(state.firestore[id].analytics.coins[pair])}
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-12 md:hidden">
                <div className="col-span-12">
                    <div className="my-3">
                        <span className="text-sm font-semibold">Trade Analytics</span>
                        <span className="mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                            By Coin
                          </span>
                    </div>
                    <div className="p-1 flex flex-row flex-wrap my-4 justify-center">
                        <div className="grid grid-cols-12 space-x-4 mb-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Winning Trades
                                </span>
                                <span className={`text-center ${state.firestore[id].analytics.coins[pair].winning_trades > 0 ? 'text-green-500' : ''}`}>
                                    {state.firestore[id].analytics.coins[pair].winning_trades}
                                </span>
                            </span>

                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Total Gains
                                </span>
                                <span className={`text-center ${Number(state.firestore[id].analytics.coins[pair].total_gain).toFixed(2) > 0.00 ? 'text-green-500' : ''}`}>
                                   $ {Number(state.firestore[id].analytics.coins[pair].total_gain).toFixed(2)}
                                </span>
                            </span>

                        </div>

                        <div className="grid grid-cols-12 space-x-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Losing Trades
                                </span>
                                <span className={`text-center ${state.firestore[id].analytics.coins[pair].losing_trades > 0 ? 'text-red-500' : ''}`}>
                                    {state.firestore[id].analytics.coins[pair].losing_trades}
                                </span>
                            </span>

                            <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Total Losses
                                </span>
                                <span className={`text-center ${Number(state.firestore[id].analytics.coins[pair].total_loss).toFixed(2) !== 0.00 ? 'text-red-500' : ''}`}>
                                    ${Number(state.firestore[id].analytics.coins[pair].total_loss).toFixed(2)}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-12">
                <div className="my-3">
                        <span className="text-sm font-semibold">Strategy Statistics</span>
                        <span className="mx-3 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-blue-100 text-blue-500 dark:text-gray-100">
                            By Coin
                          </span>
                    </div>
                    <div className="p-1 flex flex-row flex-wrap my-4 justify-center">
                        <div className="grid grid-cols-12 space-x-4 mb-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Strategy
                                </span>
                                <span className="text-center">
                                    {state.firestore[id].strategy_details.name}
                                </span>
                            </span>

                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    APPT
                                </span>
                                <span className={`text-center ${calcAPPT(state.firestore[id].analytics.coins[pair]) > 0.00 ? 'text-green-500' : 'text-red-500'}`}>
                                   $ {calcAPPT(state.firestore[id].analytics.coins[pair])}
                                </span>
                            </span>

                        </div>

                        <div className="grid grid-cols-12 space-x-4 mb-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    P(Win)
                                </span>
                                <span className={`text-center ${calcPW(state.firestore[id].analytics.coins[pair]) == 0 ? '' : 'text-green-500'}`}>
                                    {calcPW(state.firestore[id].analytics.coins[pair])}%
                                </span>
                            </span>

                            <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    P(Loss)
                                </span>
                                <span className={`text-center ${calcPL(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-red-500'}`}>
                                    {calcPL(state.firestore[id].analytics.coins[pair])}%
                                </span>
                            </span>
                        </div>

                        <div className="grid grid-cols-12 space-x-4">
                            <span className="col-span-6 flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Avg.(Win)
                                </span>
                                <span className={`text-center ${calcAvgWin(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-green-500'}`}>
                                    $ {calcAvgWin(state.firestore[id].analytics.coins[pair])}
                                </span>
                            </span>

                            <span className="col-span-6  flex flex-col justify-center text-center border rounded dark:border-gray-700 px-2 py-1 w-28">
                                <span className="text-gray-600 text-xs">
                                    Avg.(Loss)
                                </span>
                                <span className={`text-center ${calcAvgLoss(state.firestore[id].analytics.coins[pair]) === 0.00 ? '' : 'text-red-500'}`}>
                                    $ {calcAvgLoss(state.firestore[id].analytics.coins[pair])}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
